const EMPTY = new Set([null, undefined, "", "-"]);

export function hasMarketValue(value) {
  return !EMPTY.has(value);
}

function splitQuarter(n) {
  const sign = n < 0 ? -1 : 1;
  const abs = Math.abs(n);
  const frac = Number((abs % 1).toFixed(2));
  if (frac === 0.25 || frac === 0.75) {
    const low = Math.floor(abs * 2) / 2;
    return [sign * low, sign * (low + 0.5)];
  }
  return [n];
}

export function parseAsianLine(value) {
  if (!hasMarketValue(value)) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  const slash = raw.match(
    /^([+-]?\d+(?:\.\d+)?)\s*[/\-]\s*([+-]?\d+(?:\.\d+)?)$/,
  );
  if (slash) {
    const a = Number(slash[1]);
    const b = Number(slash[2]);
    if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
    return [a, b];
  }
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  return splitQuarter(n);
}

function handicapLeg(homeScore, awayScore, homeGiveLine) {
  const margin = homeScore - homeGiveLine - awayScore;
  if (margin > 0) return 1;
  if (margin < 0) return -1;
  return 0;
}

export function settleHandicap(homeScore, awayScore, line) {
  const lines = parseAsianLine(line);
  if (!lines) return null;
  const hs = Number(homeScore);
  const as = Number(awayScore);
  if (!Number.isFinite(hs) || !Number.isFinite(as)) return null;
  const sum = lines.reduce(
    (acc, l) => acc + handicapLeg(hs, as, l),
    0,
  );
  if (sum > 0) return "home";
  if (sum < 0) return "away";
  return "push";
}

function overUnderLeg(total, line) {
  const n = Math.abs(line);
  if (total > n) return 1;
  if (total < n) return -1;
  return 0;
}

export function settleOverUnder(homeScore, awayScore, line) {
  const lines = parseAsianLine(line);
  if (!lines) return null;
  const hs = Number(homeScore);
  const as = Number(awayScore);
  if (!Number.isFinite(hs) || !Number.isFinite(as)) return null;
  const total = hs + as;
  const sum = lines.reduce((acc, l) => acc + overUnderLeg(total, l), 0);
  if (sum > 0) return "over";
  if (sum < 0) return "under";
  return "push";
}

export function settle1x2(homeScore, awayScore) {
  const hs = Number(homeScore);
  const as = Number(awayScore);
  if (!Number.isFinite(hs) || !Number.isFinite(as)) return null;
  if (hs > as) return "home";
  if (hs < as) return "away";
  return "draw";
}

export function settleMatchMarkets({
  homeScore,
  awayScore,
  handicapLine,
  handicapHomeOdds,
  handicapAwayOdds,
  overUnderLine,
  overOdds,
  underOdds,
  home1x2Odds,
  drawOdds,
  away1x2Odds,
}) {
  const hdc =
    hasMarketValue(handicapLine) &&
    (hasMarketValue(handicapHomeOdds) || hasMarketValue(handicapAwayOdds))
      ? settleHandicap(homeScore, awayScore, handicapLine)
      : null;
  const ou =
    hasMarketValue(overUnderLine) &&
    (hasMarketValue(overOdds) || hasMarketValue(underOdds))
      ? settleOverUnder(homeScore, awayScore, overUnderLine)
      : null;
  const oneXTwo =
    hasMarketValue(home1x2Odds) ||
    hasMarketValue(drawOdds) ||
    hasMarketValue(away1x2Odds)
      ? settle1x2(homeScore, awayScore)
      : null;
  return { hdc, ou, oneXTwo };
}
